import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useEffect } from "react";
function Support() {
  useEffect(() => {
    window.scrollTo(0, 10);
  }, []);

  return (
    <div className="bg-gradient-custom min-vh-100">
      <Navbar />
      <div className="container py-5">
        <h2 className="font-josefin font-light text-4xl text-uppercase text-center mb-5">
          SUPPORT
        </h2>
        <div className="card mx-auto shadow-sm" style={{ maxWidth: "500px" }}>
          <div className="card-body p-5">
            <div className="mb-4">
              <label
                htmlFor="name"
                className="form-label font-josefin text-secondary"
              >
                Name
              </label>
              <input
                type="text"
                id="name"
                className="form-control"
                placeholder="Enter your name"
              />
            </div>
            <div className="mb-4">
              <label
                htmlFor="email"
                className="form-label font-josefin text-secondary"
              >
                Email
              </label>
              <input
                type="email"
                id="email"
                className="form-control"
                placeholder="Enter your email"
              />
            </div>
            <div className="mb-4">
              <label
                htmlFor="message"
                className="form-label font-josefin text-secondary"
              >
                Message
              </label>
              <textarea
                id="message"
                className="form-control"
                rows="4"
                placeholder="Your message"
              ></textarea>
            </div>
            <button className="btn btn-dark w-100 text-uppercase font-josefin">
              Submit
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Support;
